import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressBar = ({ currentSlide, totalSlides, estimatedTimeRemaining }) => {
  const progressPercentage = (currentSlide / totalSlides) * 100;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-surface border-t border-border p-4 z-10">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center space-x-2 text-sm text-text-secondary">
            <Icon name="BookOpen" size={16} />
            <span>Slide {currentSlide} of {totalSlides}</span>
          </div>
          <div className="flex items-center space-x-2 text-sm text-text-secondary">
            <Icon name="Clock" size={16} />
            <span>{estimatedTimeRemaining} remaining</span>
          </div>
        </div>
        
        <div className="w-full h-2 bg-border rounded-full overflow-hidden">
          <div 
            className="h-full bg-primary transition-all duration-300 ease-out"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
        
        <div className="flex justify-between items-center mt-2 text-xs text-text-secondary">
          <span>Progress: {Math.round(progressPercentage)}%</span>
          <span>Chapter 3: Advanced Prompting Techniques</span>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;